export default __webpack_public_path__ + "static/media/change_icon4.8fa973a3.svg";